/* eslint-disable max-lines-per-function */
import { anredeValues } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/anrede';
import { useTranslation } from 'react-i18next';
import z from 'zod';

export function usePersonSchema() {
  const { t } = useTranslation();

  const PersoenlichesSchema = z.object({
    anrede: z
      .enum(anredeValues)
      .nullable()
      .refine((val) => !!val, {
        message: t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.anrede.validationError',
        ),
      }),
    vorname: z
      .string()
      .min(
        1,
        t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.firstname.validationError',
        ),
      )
      .max(
        50,
        t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.firstname.validationErrorMaxLength',
        ),
      ),
    nachname: z
      .string()
      .min(
        1,
        t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.lastname.validationError',
        ),
      )
      .max(
        50,
        t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.lastname.validationErrorMaxLength',
        ),
      ),
    rufname: z
      .string()
      .max(
        50,
        t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.rufname.validationError',
        ),
      )
      .nullable(),
    personalnummer: z
      .string()
      .max(
        50,
        t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.personalnummer.validationError',
        ),
      )
      .nullable(),
    e2nId: z
      .string()
      .max(
        13,
        t(
          'domain.mitarbeiter.create.steps.person.persoenliches.form.e2nId.validationError',
        ),
      )
      .nullable(),
  });

  const ArbeitsbereicheSchema = z.object({
    primaererArbeitsbereich: z.string().min(1, {
      error: t(
        `domain.mitarbeiter.create.steps.person.arbeitsbereiche.form.primaererArbeitsbereich.validationError`,
      ),
    }),
    sekundaereArbeitsbereiche: z.string().array(),
    erfahrungslevel: z.string().nullable(),
  });

  const KontaktSchema = z.object({
    email: z
      .email({
        error: t(
          'domain.mitarbeiter.create.steps.person.kontakt.form.email.validationError',
        ),
      })
      .nullable(),
    mobilnummer: z
      .string()
      .regex(/^[\d\s()+-]+$/, {
        error: t(
          'domain.mitarbeiter.create.steps.person.kontakt.form.phone.validationError',
        ),
      })
      .nullable(),
    /**
     * Dieses Feld wurde nur hinzugefügt um die TypeInferenz ohne strict mode zu gewährleisten, da die restlichen Felder alle optional sind. Es sollte nicht in der UI verwendet werden.
     * TODO: Entfernen sobald strict mode aktiv ist
     * */
    strict: z.boolean(),
  });

  return {
    PersoenlichesSchema,
    ArbeitsbereicheSchema,
    KontaktSchema,
  };
}
